import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpLoaderFactory} from "./pages/translated.page";
import {VetineoComponentsModule} from "./utils/vetineo-components/vetineo-components.module";
import {UserResolve} from "./resolvers/users.resolve";
import {OrdersResolve} from "./resolvers/orders.resolve";
import {NgxDropzoneModule} from "ngx-dropzone";
import {VetReservationsResolve} from "./resolvers/vet-reservations-resolve.service";
import {VetClinicResolve} from "./resolvers/vet-clinic.resolve";
import {IonicStorageModule} from '@ionic/storage-angular';
import {LeadsResolve} from "./resolvers/leads.resolve";
import {ClientsResolve} from "./resolvers/clients.resolve";
import {PartnersResolve} from "./resolvers/partners.resolve";
import {VetClinicsResolve} from "./resolvers/vet-clinics.resolve";
import {VetReservationResolve} from "./resolvers/vet-reservation-resolve";
import {SummarySettlementsResolve} from "./resolvers/summary-settlements.resolve";
import {OrderSettlementsResolve} from "./resolvers/order-settlements.resolve";
import {PartnerBannersResolve} from "./resolvers/partner-banners.resolve";
import {PartnerBannersActionResolve} from "./resolvers/partner-banner-actions.resolve";
import {VMessagesResolve} from "./resolvers/v-messages.resolve";
import {VrdResolve} from "./resolvers/vrd.resolve";
import {AppUserResolve} from "./resolvers/app-user.resolve";
import {RefundRequestResolve} from "./resolvers/refund-request.resolve";
import {UserResignationResolve} from "./resolvers/user-resignation.resolve";
import {MonthlyReportsForClinicResolve} from "./resolvers/monthly-reports-for-clinic.resolve";
import {PaymentMethodsResolve} from "./resolvers/payment-methods.resolve";
import {MonthlyReportsForClientResolve} from "./resolvers/monthly-reports-for-client.resolve";
import {ArticlesResolve} from "./resolvers/articles.resolve";
import {QuillModule} from "ngx-quill";
import {NgChartsModule} from "ng2-charts";
import {LabTestDataResolve} from "./resolvers/lab-test-data.resolve";
import {ReferralsResolve} from "./resolvers/referrals.resolve";
import {SupportResolve} from "./resolvers/support.resolve";
import {VetineoVisitTypeBundleResolve} from "./resolvers/vetineo-visit-type-bundle.resolve";
import {VetDoctorVetVisitTypeResolve} from "./resolvers/vet-doctor-vet-visit-type.resolve";
import {WellnessPlansResolve} from "./resolvers/wellness-plans.resolve";
import {CarePlanServiceResolve} from "./resolvers/care-plan-service.resolve";
import {UserCarePlanResolve} from "./resolvers/user-care-plan.resolve";
import {UserCarePlanItemsDetailsResolve} from "./resolvers/user-care-plan-items-details.resolve";
import {UserCarePlanVisitTypeDetailsResolve} from "./resolvers/user-care-plan-visit-type-details.resolve";
import {PartnerProductResolve} from "./resolvers/partner-product.resolve";
import {ProductRecommendationResolve} from "./resolvers/product-recommendation.resolve";
import {PartnerShopOrderResolve} from "./resolvers/partner-shop-order.resolve";
import {CarePlanServiceGroupTypesResolve} from "./resolvers/care-plan-service-group-types.resolve";
import {OrderDetailResolve} from "./resolvers/order-detail.resolve";
import {registerLocaleData} from "@angular/common";
import localePl from '@angular/common/locales/pl';
import {MockBackendInterceptor} from "./utils/mock-backend-interceptor";
import {environment} from "../environments/environment";

registerLocaleData(localePl);

const conditionalProviders = environment.useMock ? [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MockBackendInterceptor,
    multi: true
  }
] : [];

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    NgxDropzoneModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot({
      name: '__vetineo_dashboard'
    }),
    QuillModule.forRoot(),
    NgChartsModule,
    VetineoComponentsModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    ...conditionalProviders,
    {
    provide: RouteReuseStrategy,
    useClass: IonicRouteStrategy
  }, UserResolve, PartnersResolve, OrdersResolve, VetClinicsResolve, ClientsResolve, LeadsResolve, VetReservationsResolve, PaymentMethodsResolve,
    VetClinicResolve, VetReservationResolve, PartnerBannersResolve, SummarySettlementsResolve, OrderSettlementsResolve, PartnerBannersResolve,
    PartnerBannersActionResolve, VMessagesResolve, VrdResolve, AppUserResolve, RefundRequestResolve, UserResignationResolve, MonthlyReportsForClinicResolve,
    MonthlyReportsForClientResolve, ArticlesResolve, LabTestDataResolve, ReferralsResolve, SupportResolve, VetineoVisitTypeBundleResolve, VetDoctorVetVisitTypeResolve,
    WellnessPlansResolve, CarePlanServiceResolve, UserCarePlanResolve, UserCarePlanItemsDetailsResolve, UserCarePlanVisitTypeDetailsResolve, PartnerProductResolve, ProductRecommendationResolve, PartnerShopOrderResolve, CarePlanServiceGroupTypesResolve, OrderDetailResolve
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
